export default __webpack_public_path__ + "static/media/7.e9a46993.jpg";